import type { LiveTvProgram } from '../../api/types';

/// When a programme is on: the times, and the day as well when it is not today - a search
/// finds next Saturday's match, and "20:15 – 22:00" alone would say tonight.
///
/// The locale is the interface language, not the browser's: somebody reading Emiro in German
/// on an English computer wants "Sa., 4. Okt.", and the browser would have said "Sat, Oct 4".
export function programmeTimes(program: LiveTvProgram, locale?: string): string {
  const startsAt = new Date(program.startsAt);
  const endsAt = new Date(program.endsAt);
  const time: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit' };
  const today = startsAt.toDateString() === new Date().toDateString();

  const start = today
    ? startsAt.toLocaleTimeString(locale, time)
    : startsAt.toLocaleString(locale, { weekday: 'short', day: 'numeric', month: 'short', ...time });

  return `${start} – ${endsAt.toLocaleTimeString(locale, time)}`;
}
